// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// OWASP RISK DATA SCHEMA
/////////////////////////////////////////

export const OwaspRiskDataSchema = z.object({
  score: z.string(),
  vector: z.string(),
  level: z.string(),
})

export type OwaspRiskData = z.infer<typeof OwaspRiskDataSchema>

export default OwaspRiskDataSchema;
